/**
 * @generated SignedSource<<571e185e13c8bf8a0bc27ba4310e5391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type signUpButtonNewsletter$data = ReadonlyArray<{
  readonly entityId: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "signUpButtonNewsletter";
}>;
export type signUpButtonNewsletter$key = ReadonlyArray<{
  readonly " $data"?: signUpButtonNewsletter$data;
  readonly " $fragmentSpreads": FragmentRefs<"signUpButtonNewsletter">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "signUpButtonNewsletter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Newsletter",
  "abstractKey": null
};

(node as any).hash = "88d34bf444c115cadec767575f9839cc";

export default node;
